import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ActivePackage.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Chip } from '@/components/UI/Chip/Chip';

export const ActivePackage = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <Typography.Header $variant="2">Basic</Typography.Header>
      <S.ItemTitle>{t('pages.cabinet.for_promotion_services')}</S.ItemTitle>
      <S.PriceBox>
        <Typography.Header $variant="2">300 AZN</Typography.Header>
        <Chip isRounded size="m" appearance="green">
          + {t('common.discount_percent', { discount: '10' })}
        </Chip>
      </S.PriceBox>

      <S.ItemTitle>{t('pages.cabinet.of_ads')}</S.ItemTitle>
      <Typography.Header $variant="2">250</Typography.Header>

      <S.ItemTitle>{t('pages.cabinet.expiration_date')}</S.ItemTitle>
      <Typography.Header>13 сентября 2023</Typography.Header>
      <S.Progress $progress={80} />

      <S.ProlongateButton appearance="secondary" isFullWidth>
        {t('pages.cabinet.continue_package', { name: 'Gold' })}
      </S.ProlongateButton>
    </S.Box>
  );
};
